import {initReactI18next} from 'react-i18next';
import i18next from 'i18next';
import Backend from 'i18next-http-backend';

// eslint-disable-next-line import/no-named-as-default-member
i18next
  .use(initReactI18next)
  .use(Backend)
  .init({
    ns: ['en'],
    defaultNS: 'en',
    debug: false,
    backend: {
      // for all available options read the backend's repository readme file
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  });

export default i18next;
